// extracted by mini-css-extract-plugin
export default {"error_text":"textfield_error_text__1x3Tr"};